import React, { useState, useEffect, Fragment, memo } from 'react';
import { useFormikContext } from 'formik';
import ToggleSelect from '../../../../../common/components/ToggleSelect/ToggleSelect';
import RadioButton from '../../../../../components/Dashboard-res/CommonComponent/RadioButton';
import _ from 'lodash';
import {
        getLAPType, 
        setLoanProducts,
        getCustomerDetails
      } from '../../../../../common/constants/api'
import { getApplicantionInfo } from '../../../../../common/utils/applicantionInfo';
import withErrorHandler from '../../../../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../../../../common/components/PopUp/PopUp';

  
const LAPTypeSelection = () => {
  const [LeadId, SetLeadId] = useState(getApplicantionInfo().leadId);
  const [data, setData] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  

  const {
    values,
    errors,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = useFormikContext();

  //get List of LAP
  useEffect(() => {
    setType('loading');
    setText('Loading...');
    setShow(true);
    getLAPType()
      .then(res => {
        setData(res);
        setShow(false);
      })
      .catch(err => {
        setShow(false);
        
      });
  }, []);

  //get Selected Loan 
  useEffect(() => {
    setType('loading');
    setText('Loading...');
    setShow(true);
      getCustomerDetails(LeadId)
        .then(res => {
          setFieldValue('LAPType', res?.subProductName);
          setFieldValue('LAPTypeID', res?.subProductId);
          setShow(false);
        })
        .catch(err => {
          setShow(false);
        });
  }, []);

 //save loan type

  function saveLoanType(){
    setType('loading');
    setText('Adding Loan Please Wait..');
    setShow(true);
     setLoanProducts(LeadId, values.LAPTypeID)
      .then(res => {
        if (res?.error) {
          throw new Error(res);
        } else {
          handleSubmit();
        }
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  };

   return(
    <React.Fragment>
        <PopUp type={type} text={text} setShow={setShow} show={show} />
    <div className="px-5">
      <p className="pt-2 text-black-850 text-base font-medium font-roboto">
        Type of LAP
      </p>
      <div className="md:flex md:flex-wrap md:justify-start ">

        {data &&
        data.map(each => {
            return (
              <div key={each?.id}>
                <div className="flex my-4 mx-2 hidden md:block">

                  <ToggleSelect
                    img={each?.imgUrl}
                    name={each?.displayName}
                    value={each?.displayName}
                    checked={values.LAPTypeID === each?.id}
                    onChange={e => {
                      setFieldValue(
                        'LAPType',
                        each?.displayName
                      );
                      setFieldValue('LAPTypeID', each?.id);
                    }}
                    addClasses="cursor-pointer hover:bg-green-100 hover:border-green-1000 mb-8"
                    containerStyle={{
                      width: '7.5rem',
                      height: '100px',
                      marginRight: '20px'
                    }}
                    nameDisplay={each?.displayName}
                    namingStyle={{
                    paddingTop: '40px',
                    color: values.LAPTypeID === each?.id ? '#00ACB8'  : '#7B8C9B'
                    }}
                  />
                </div>

                <div className="block w-full md:hidden flex my-3">
                  <div className="font-robot font-normal text-sm text-grey-2000">
                    {each?.displayName}
                  </div>
                  <div className="ml-auto">
                    <RadioButton
                      name={each?.displayName}
                      checked={values.LAPTypeID === each?.id}
                      onChange={e => {
                        setFieldValue('LAPType', each?.displayName);
                        setFieldValue('LAPTypeID', each?.id);
                      }}

                    />
                  </div>
                </div>
              </div>

            );

          })}

      </div>
      <div className="mt-28">
        <button
          type="button"
          disabled={!_.isEmpty(errors)}
          className="submitButton font-roboto text-white text-base w-48 "
          onClick={()=> {values?.LAPTypeID ? saveLoanType() : null}}

        >
          NEXT

        </button>

      </div>

    </div>
  </React.Fragment>
   );

}
export default memo(withErrorHandler(LAPTypeSelection));